import { render } from "./ResourceIcon.vue?vue&type=template&id=538920ca&ts=true"
import script from "./ResourceIcon.vue?vue&type=script&lang=ts"
export * from "./ResourceIcon.vue?vue&type=script&lang=ts"

import "./ResourceIcon.vue?vue&type=style&index=0&id=538920ca&lang=scss"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__